export const administrationPage = {
  menu: {
    users: 'Benutzerverwaltung',
    organizations: 'Organisationen',
    offers: 'Angebotsübersicht',
    dashboard: 'Dashboard'
  }
};

export const administrationDashboardPage = {
  iframeTitle: 'Grafana-Dashboard Betreiber',
  openInNewTab: 'In neuem Tab öffnen',
  unconfigured:
    'Das Dashboard ist für diese Instanz nicht konfiguriert. Bitte VITE_GRAFANA_DASHBOARD_URL beim Deployment setzen.'
};

export const administrationUsersPage = {
  users: 'Benutzerverwaltung',
  search: 'Suchen',
  searchPlaceholder: 'Name oder E-Mail',
  loading: 'Aktualisiere…',
  neverLoggedIn: 'Noch nie angemeldet',
  noOrganizations: '—',
  openUserOffers: 'Angebote von {{name}} in der Angebotsübersicht anzeigen',
  openOrganization:
    'Organisation {{name}} in der Organisationsverwaltung anzeigen',
  pageSize: 'Einträge pro Seite',
  roleFilter: {
    label: 'Rolle',
    all: 'Alle',
    platformAdministrator: 'Administrator'
  },
  columns: {
    name: 'Name',
    email: 'E-Mail-Adresse',
    accountType: 'Kontotyp',
    organizations: 'Organisationen',
    status: 'Aktiv',
    administrator: 'Rolle',
    lastLogin: 'Letzte Anmeldung',
    actions: 'Aktionen'
  },
  accountType: {
    private: 'Privat',
    business: 'Geschäftlich'
  },
  status: {
    active: 'Aktiv',
    disabled: 'Deaktiviert'
  },
  administrator: {
    yes: 'Administrator',
    no: 'Benutzer'
  },
  actions: {
    label: 'Aktionen',
    enable: 'Konto aktivieren',
    disable: 'Konto deaktivieren',
    grantAdmin: 'Zum Administrator ernennen',
    revokeAdmin: 'Administratorrolle entfernen'
  },
  disableConfirmation: {
    title: 'Konto deaktivieren?',
    content:
      'Möchtest du das Konto von {{name}} wirklich deaktivieren? Der Benutzer kann sich danach nicht mehr anmelden.',
    confirm: 'Konto deaktivieren',
    cancel: 'Abbrechen'
  },
  empty: {
    top: 'Keine Benutzer gefunden',
    bottom: 'Passe die Suche an oder prüfe später erneut.'
  },
  toasts: {
    enabledUpdated: 'Kontostatus aktualisiert',
    roleUpdated: 'Administratorrolle aktualisiert',
    actionFailed: 'Aktion fehlgeschlagen'
  }
};

export const administrationOrganizationsPage = {
  search: 'Suchen',
  searchPlaceholder: 'Name, E-Mail oder Adresse',
  pageSize: 'Einträge pro Seite',
  emptyValue: '—',
  openMemberUser:
    'Mitglied {{email}} in der Benutzerverwaltung anzeigen',
  openOrganizationOffers:
    'Angebote der Organisation {{name}} in der Angebotsübersicht anzeigen ({{count}})',
  columns: {
    name: 'Name',
    email: 'E-Mail',
    address: 'Adresse',
    members: 'Mitglieder',
    offers: 'Angebote'
  },
  empty: {
    top: 'Keine Organisationen gefunden',
    bottom: 'Passe die Suche an oder prüfe später erneut.'
  }
};

export const administrationOffersPage = {
  search: 'Suchen',
  searchPlaceholder: 'Angebotsname, Organisation oder Anbieter',
  pageSize: 'Einträge pro Seite',
  untitledOffer: 'Ohne Titel',
  emptyValue: '—',
  missingOrganizationBadge: 'Organisation fehlt',
  missingOrganizationBadgeTitle:
    'Für dieses gewerbliche Angebot ist keine gültige Organisation mehr verknüpft.',
  emailProvider: 'E-Mail an {{email}} senden',
  openProviderUser: 'Benutzer {{email}} in der Benutzerverwaltung anzeigen',
  openOrganization:
    'Organisation {{name}} in der Organisationsverwaltung anzeigen',
  typeFilter: {
    label: 'Art',
    all: 'Alle',
    ROOM: 'Räume',
    MATERIAL: 'Gegenstände'
  },
  statusFilter: {
    label: 'Status',
    all: 'Alle',
    draft: 'Entwurf',
    published: 'Veröffentlicht'
  },
  availabilityFilter: {
    label: 'Zustand',
    active: 'Aktive',
    suspended: 'Gesperrt',
    removed: 'Entfernt',
    all: 'Alle'
  },
  sort: {
    label: 'Sortieren nach',
    'name-asc': 'Angebotstitel: A–Z',
    'name-desc': 'Angebotstitel: Z–A',
    'publishedAt-desc': 'Veröffentlicht am: Neueste zuerst',
    'publishedAt-asc': 'Veröffentlicht am: Älteste zuerst'
  },
  columns: {
    type: 'Art',
    offer: 'Angebot',
    status: 'Status',
    publishedAt: 'Veröffentlicht am',
    provider: 'Anbieter',
    providerType: 'Anbieterart',
    organization: 'Organisation',
    bookings: 'Buchungen',
    bookingRequests: 'Anfragen',
    actions: 'Aktionen'
  },
  offerType: {
    room: 'Raum',
    material: 'Gegenstand'
  },
  offerStatus: {
    published: 'Veröffentlicht',
    draft: 'Entwurf',
    suspended: 'Gesperrt',
    reviewRequested: 'Prüfung angefordert',
    removed: 'Entfernt'
  },
  providerType: {
    private: 'Privat',
    business: 'Geschäftlich'
  },
  actions: {
    label: 'Aktionen',
    lock: 'Angebot sperren',
    unlock: 'Angebot freigeben',
    remove: 'Angebot entfernen'
  },
  lockConfirmation: {
    title: 'Angebot sperren?',
    content:
      'Möchtest du das Angebot „{{name}}“ vorübergehend sperren? Es wird öffentlich ausgeblendet und neue Buchungen werden verhindert.',
    reasonLabel: 'Sperrgrund (Pflichtfeld)',
    reasonPlaceholder: 'Grund der Sperre',
    messageLabel: 'Nachricht an den Anbieter (optional)',
    messagePlaceholder: 'Optionale Nachricht',
    confirm: 'Angebot sperren',
    cancel: 'Abbrechen'
  },
  unlockConfirmation: {
    title: 'Angebot freigeben?',
    content:
      'Möchtest du die Sperre für das Angebot „{{name}}“ aufheben? Der Veröffentlichungsstatus bleibt unverändert.',
    confirm: 'Angebot freigeben',
    cancel: 'Abbrechen'
  },
  removeConfirmation: {
    title: 'Angebot dauerhaft entfernen?',
    content:
      'Möchtest du das Angebot „{{name}}“ dauerhaft entfernen? Diese Aktion kann nicht rückgängig gemacht werden. Offene Anfragen und zukünftige Buchungen werden storniert. Vergangene Buchungen bleiben erhalten.',
    reasonLabel: 'Entfernungsgrund (Pflichtfeld)',
    reasonPlaceholder: 'Grund der Entfernung',
    messageLabel: 'Nachricht an den Anbieter (optional)',
    messagePlaceholder: 'Optionale Nachricht',
    confirm: 'Angebot entfernen',
    cancel: 'Abbrechen'
  },
  empty: {
    top: 'Keine Angebote gefunden',
    bottom: 'Passe die Suche an oder prüfe später erneut.'
  }
};
